/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutExperimentationSettingsPathParams = NonNullable<
  operations['putExperimentationSettings']['parameters']['path']
>;

export type PutExperimentationSettingsRequestBody = OperationRequestBodyContent<
  operations['putExperimentationSettings']
>;

export interface Input extends PutExperimentationSettingsPathParams {
  apiVersion?: string;
  body: PutExperimentationSettingsRequestBody;
}

export async function putExperimentationSettings(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/api/v2/projects/{projectKey}/experimentation-settings', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
